import { MapPin, Phone, Mail } from "@/components/icons";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaXTwitter,
  FaYoutube,
} from "react-icons/fa6";
import LINKS, { LINKS_NAVITEMS } from "./links";

import BlogsCardImage from "@/assets/images/home/blogs-card-image.jpeg";
import EventsCardImage from "@/assets/images/home/events-card-image.jpeg";
import {
  StaticImageData,
  StaticImport,
} from "next/dist/shared/lib/get-img-props";

import DefaultImage from "@/assets/images/inquiry/default_v2.jpeg";
import HomeCareImage from "@/assets/images/inquiry/home-care.jpeg";
import OneOnOneHospitalSitterImage from "@/assets/images/inquiry/one-on-one-hospital-sitter.jpeg";
import LongTermCareImage from "@/assets/images/inquiry/long-term-care.jpeg";
import PrivateDutyMedicalCareImage from "@/assets/images/inquiry/private-duty-medical-care.jpeg";
import SpecializedCareImage from "@/assets/images/inquiry/specialized-care.jpeg";
import DiseaseSpecialtiesImage from "@/assets/images/inquiry/disease-specialties.jpeg";
import MedicalStaffingImage from "@/assets/images/inquiry/medical-staffing.jpeg";
import ExtraSupportForFamiliesImage from "@/assets/images/inquiry/extra-support-for-families.jpeg";
import { ReactNode } from "react";
import { CALLRAIL_HREF, CALLRAIL_PRETTY } from "./utils";

// SOCIAL PROOF CUSTOMER STORIES
import HelenPreviewImage from "@/assets/images/social-proof/customer-stories/helen-preview-image.png";
import MartinPreviewImage from "@/assets/images/social-proof/customer-stories/martin-preivew-image.png";
import ElisePreviewImage from "@/assets/images/social-proof/customer-stories/elise-preview-image.png";

// SOCIAL PROOF RATINGS LOGOS
import GoogleLogo from "@/assets/images/social-proof/logos/google.png";
import CaringLogo from "@/assets/images/social-proof/logos/caring.png";
import IndeedLogo from "@/assets/images/social-proof/logos/indeed.png";
import APlaceForMomLogo from "@/assets/images/social-proof/logos/a-place-for-mom.png";
import TrustPilotLogo from "@/assets/images/social-proof/logos/trustpilot.png";
import GlassDoorLogo from "@/assets/images/social-proof/logos/glassdoor.png";
import YelpLogo from "@/assets/images/social-proof/logos/yelp.png";
import FacebookLogo from "@/assets/images/social-proof/logos/facebook.png";

// SOCIAL PROOF TESTIMONIAL AVATARS
import DDAvatar from "@/assets/images/social-proof/avatars/DD.jpeg";
import CarolAvatar from "@/assets/images/social-proof/avatars/Carol.jpeg";
import AlexandraAvatar from "@/assets/images/social-proof/avatars/Alexandra.jpeg";
import RashmiAvatar from "@/assets/images/social-proof/avatars/Rashmi.jpeg";
import DianeAvatar from "@/assets/images/social-proof/avatars/Diane.jpeg";
import GloriaAvatar from "@/assets/images/social-proof/avatars/Gloria.jpeg";
import MarilynAvatar from "@/assets/images/social-proof/avatars/Marilyn.jpeg";
import AndreaAvatar from "@/assets/images/social-proof/avatars/Andrea.jpeg";
import LisaAvatar from "@/assets/images/social-proof/avatars/Lisa.jpeg";

// SOCIAL PROOF TESTIMONIALS PROFESSIONALS
import AmanjitPreviewImage from "@/assets/images/social-proof/testimonials-professionals/amanjit-preview-image.png";
import KevinPreviewImage from "@/assets/images/social-proof/testimonials-professionals/kevin-preview-image.png";

// ABOUT US - OUR LOCATIONS
import CampbellLogo from "@/assets/images/about-us/campbell.png";
import MenloParkLogo from "@/assets/images/about-us/menlo-park.png";
import SanMateoLogo from "@/assets/images/about-us/san-mateo.png";
import SanJoseLogo from "@/assets/images/about-us/san-jose.png";

// ABOUT US - SERVICES ABOUT US
import ServicesForFamiliesHeaderImage from "@/assets/images/services-for-families/services-for-families-header-image.jpeg";
import MedicalStaffingHeaderImage from "@/assets/images/medical-staffing/medical-staffing-header-image.jpeg";
import { LocationsServiceType } from "@/components/sections/locations-services";

export type Menu = {
  title: string;
  url: string;
  prefetch?: boolean;
};

export type Section = {
  header: string;
  menus: Menu[];
};

export type Footer = {
  logo: string;
  sections: Section[];
};

export const footer: Footer = {
  logo: "https://cdn.careindeed.com/new-logo.png",
  sections: [
    {
      header: "Services",
      menus: [
        {
          title: LINKS.servicesForFamilies.title,
          url: LINKS.servicesForFamilies.href,
        },
        {
          title: LINKS.medicalStaffing.title,
          url: LINKS.medicalStaffing.href,
        },
        {
          title: LINKS.resources.title,
          url: LINKS.resources.href,
          prefetch: !LINKS.resources.doNotPrefetch,
        },
      ],
    },
    {
      header: "About us",
      menus: [
        {
          title: "Our Story",
          url: "/about-us",
          prefetch: false,
        },
        {
          title: "Testimonials",
          url: "/testimonial",
          prefetch: false,
        },
        {
          title: "Blogs",
          url: "/blogs",
          prefetch: false,
        },
        {
          title: "Events",
          url: "/events",
          prefetch: false,
        },
      ],
    },
    {
      header: "Careers",
      menus: [
        {
          title: "Open Positions",
          url: LINKS.careers.href,
          prefetch: false,
        },
      ],
    },
    {
      header: "Legal",
      menus: [
        {
          title: "Notice of Privacy",
          url: "/notice-of-privacy",
          prefetch: false,
        },
        {
          title: "Privacy Policy",
          url: "/privacy-policy",
          prefetch: false,
        },
        {
          title: "Terms of Use",
          url: "/terms-of-use",
          prefetch: false,
        },
      ],
    },
  ],
};

export const contactIconList = ["map-pin", "phone", "mail", "clock"] as const;

export type Contact = {
  icon: React.ReactNode;
  title: string;
  url: string;
  id?: string;
};

export const contacts: Contact[] = [
  {
    icon: MapPin(),
    title: "419 E. Hamilton Avenue Campbell, CA 95008",
    url: "/campbell",
  },
  {
    icon: Phone(),
    title: CALLRAIL_PRETTY,
    url: CALLRAIL_HREF,
    id: "hotline-footer",
  },
  {
    icon: Mail(),
    title: "info@careindeed.com",
    url: "mailto:info@careindeed.com",
  },
];

export type Social = {
  name: string;
  icon: ReactNode;
  url: string;
};

export const socials: Social[] = [
  {
    name: "Facebook Icon",
    icon: <FaFacebookF />,
    url: "https://www.facebook.com/careindeedhomecare/",
  },
  {
    name: "Twitter Icon",
    icon: <FaXTwitter />,
    url: "https://twitter.com/careindeed1",
  },
  {
    name: "LinkedIn Icon",
    icon: <FaLinkedinIn />,
    url: "https://www.linkedin.com/company/care-indeed",
  },
  {
    name: "Youtube Icon",
    icon: <FaYoutube />,
    url: "https://www.youtube.com/user/BestSeniorHomecare",
  },
];

export const buildRewardingCareerCards = [
  {
    title: "Certified Nurse Aide",
    description:
      "Provide essential hands-on care to patients, assisting with activities of daily living such as bathing, dressing, and feeding, under the supervision of licensed nurses.",
  },
  {
    title: "Licensed Vocational Nurses",
    description:
      "Provide basic nursing care, including administering medications, wound care, and monitoring patient health, under the direction of registered nurses and doctors.",
  },
  {
    title: "Registered Nurses",
    description:
      "Assess and monitor patient health, administer treatments and medications, and coordinate care plans",
  },
  {
    title: "Caregivers",
    description:
      "Assist individuals with daily tasks such as bathing, dressing, meal preparation, and medication reminders",
  },
  {
    title: "Medication Technicians",
    description:
      "Perform laboratory tests and analyze samples to help diagnose and treat diseases, working behind the scenes in clinical labs.",
  },
  {
    title: "Office Staff",
    description:
      "Provide friendly and professional client assistance, manage calls, schedule appointments, handle administrative tasks, and maintain a clean and organized front office.",
  },
];

export type NavItem = {
  href: string;
  displayName: string;
  nest: string;
  subMenu?: NavItem[];
  mobileOnly?: boolean;
};

export const navItems: NavItem[] = LINKS_NAVITEMS;

export type CardInfo = {
  title: string;
  description: string;
  image: {
    src: string | StaticImport;
    alt: string;
  };
  cta: {
    href: string;
    text: string;
    prefetch?: boolean;
  };
};

export const CARDS_DATA: CardInfo[] = [
  {
    title: "Blogs",
    description:
      "Our expert-written content provides valuable information, tips, and resources to help you and your loved ones find the care you need.",
    image: {
      src: BlogsCardImage,
      alt: "Blogs card image",
    },
    cta: {
      href: LINKS.blog.href,
      text: "Read Our Blog",
      prefetch: !LINKS.blog.doNotPrefetch,
    },
  },
  {
    title: "Events",
    description:
      "We host workshops and community events to help families, caregivers, and professionals stay informed and connected with each other.",
    image: {
      src: EventsCardImage,
      alt: "Events card image",
    },
    cta: {
      href: LINKS.events.href,
      text: "View All Events",
      prefetch: !LINKS.events.doNotPrefetch,
    },
  },
];

export type NewsData = {
  title: string;
  titleHref: string;
  image: {
    src: string;
    alt: string;
  };
  leftInfo: string;
  rightInfo: string;
};

export const NEWS_DATA: NewsData[] = [
  {
    title:
      "Test Gerontologist Amy LaGrant Headlines Care Indeed Event, Offering Families New Perspectives for Coping with Dementia",
    titleHref: "#",
    image: {
      src: "https://via.placeholder.com/400",
      alt: "Resources",
    },
    leftInfo: "EIN Presswire",
    rightInfo: "August 1, 2024",
  },
  {
    title: "Test Care Indeed Won Great Place To Work Certified™ ",
    titleHref: "#",
    image: {
      src: "https://via.placeholder.com/400",
      alt: "Resources",
    },
    leftInfo: "Great Place To Work Institute",
    rightInfo: "August 2022",
  },
  {
    title:
      "Test Care Indeed Marks 13th Anniversary with Inauguration of San Jose Office",
    titleHref: "#",
    image: {
      src: "https://via.placeholder.com/400",
      alt: "Resources",
    },
    leftInfo: "EIN Presswire",
    rightInfo: "September 29, 2023",
  },
  {
    title: "Test Care Indeed - Best Workplaces in the Bay Area™ 2019 ",
    titleHref: "#",
    image: {
      src: "https://via.placeholder.com/400",
      alt: "Resources",
    },
    leftInfo: "Great Place To Work Institute",
    rightInfo: "2019",
  },
  {
    title:
      "Test Care Indeed Receives 2023 Best of Home Care® – Leader in Experience Award",
    titleHref: "#",
    image: {
      src: "https://via.placeholder.com/400",
      alt: "Resources",
    },
    leftInfo: "Great Place To Work Institute",
    rightInfo: "2019",
  },
];

export type TestimonialData = {
  stars?: number;
  name?: string;
  date?: string;
  text?: string;
  imageURL?: string;
};

export const TESTIMONIAL_DATA: TestimonialData[] = [
  {
    stars: 5,
    name: "Carol I.",
    date: "MAY 2024",
    text: `I cannot say enough good things about the staff and caregivers at Care Indeed. They are easy to deal with & I highly recommend them.`,
    imageURL: CarolAvatar.src,
  },
  {
    stars: 5,
    name: "Alexandra R.",
    date: "APR 2024",
    text: `Care Indeed is a reliable company to use when in a pinch for staffing. Every time I call, I am met with exceptional customer service.`,
    imageURL: AlexandraAvatar.src,
  },
  {
    stars: 5,
    name: "D. D.",
    date: "MAY 2024",
    text: `After years of struggling with other agencies, everything about my Mother's care improved after we started working with Care Indeed.`,
    imageURL: DDAvatar.src,
  },
];

// SOCIAL PROOF TESTIMONIALS
export const AROUND_THE_WEB_TESTIMONIAL_DATA: TestimonialData[] = [
  {
    text: `After years of struggling with other agencies, everything about my Mother's care improved after we started working with Care Indeed.`,
    name: "D.D.",
    date: "JUL 2024",
    imageURL: DDAvatar.src,
  },
  {
    text: `I cannot say enough good things about the staff and caregivers at Care Indeed. They are easy to deal with & I highly recommend them.`,
    name: "Carol",
    date: "MAY 2024",
    imageURL: CarolAvatar.src,
  },
  {
    text: `Care Indeed is a reliable company to use when in a pinch for staffing. Every time I call, I am met with exceptional customer service.`,
    name: "Alexandra",
    date: "APR 2024",
    imageURL: AlexandraAvatar.src,
  },
  {
    text: `Care Indeed gave me the golden opportunity to make senior citizens happy. Care Indeed is a great place to work ❤️.`,
    name: "Rashmi",
    date: "FEB 2024",
    imageURL: RashmiAvatar.src,
  },
  {
    text: `This is a wonderful company that provides quality home caring attendants. Their attendants have been very compassionate.`,
    name: "Diane",
    date: "JAN 2024",
    imageURL: DianeAvatar.src,
  },
  {
    text: `Best agency ever. They will take care of you from the start of the application until you get a client. I'm happy to be a part of the team!`,
    name: "Gloria",
    date: "JAN 2024",
    imageURL: GloriaAvatar.src,
  },
  {
    text: `Care Indeed people are the best so far I worked with in a caregiving job. They take time to listen with compassion and respect.`,
    name: "Marilyn",
    date: "AUG 2023",
    imageURL: MarilynAvatar.src,
  },
  {
    text: `Caregivers have been professional, courteous, personable and courteous and on time. I definitely recommend Care Indeed.`,
    name: "Andrea",
    date: "MAR 2023",
    imageURL: AndreaAvatar.src,
  },
  {
    text: `Care Indeed has been supporting my mother for the last five years showing compassion, flexibility, and providing excellent care.`,
    name: "Lisa",
    date: "MAY 2022",
    imageURL: LisaAvatar.src,
  },
];

export type Rating = {
  value: string;
  logo: {
    src: string | StaticImport;
    alt: string;
  };
};

// SOCIAL PROOF RATINGS
export const AROUND_THE_WEB_RATINGS: Rating[] = [
  {
    value: "5.0",
    logo: {
      src: GoogleLogo,
      alt: "Google",
    },
  },
  {
    value: "4.5",
    logo: {
      src: CaringLogo,
      alt: "Caring",
    },
  },
  {
    value: "4.2",
    logo: {
      src: IndeedLogo,
      alt: "Indeed",
    },
  },
  {
    value: "4.5",
    logo: {
      src: APlaceForMomLogo,
      alt: "A Place For Mom",
    },
  },
  {
    value: "4.7",
    logo: {
      src: TrustPilotLogo,
      alt: "TrustPilot",
    },
  },
  {
    value: "4.2",
    logo: {
      src: GlassDoorLogo,
      alt: "GlassDoor",
    },
  },
  {
    value: "4.1",
    logo: {
      src: YelpLogo,
      alt: "Yelp",
    },
  },
  {
    value: "4.7",
    logo: {
      src: FacebookLogo,
      alt: "Facebook",
    },
  },
];

export type ServiceData = {
  count: number;
  label: string;
};

export const SERVICE_DATA: ServiceData[] = [
  {
    count: 5000,
    label: "served customers",
  },
  {
    count: 10000,
    label: "shifts filled",
  },
  {
    count: 100,
    label: "partner facilities",
  },
];

export type InquiryContent = {
  title: string;
  description: string;
};

export type InquiryInfoGroup = {
  header?: string;
  image?: {
    src: string | StaticImport;
    alt: string;
  };
  content: InquiryContent[];
};

export type InquiryInfoList = {
  [key: string]: InquiryInfoGroup;
};

// Ref: https://stackoverflow.com/questions/60748162/how-to-make-use-of-keyof-typeof-myrecord-when-myrecord-is-already-typed-as-rec
function makeGroup<T extends InquiryInfoList>(input: T) {
  return input;
}

export const inquiryInfoList = makeGroup({
  default: {
    header: "Services",
    image: {
      src: DefaultImage,
      alt: "Services Image",
    },
    content: [
      {
        title: "Services for Families",
        description: `Care Indeed’s Services for Families offers compassionate, professional support tailored to meet each family’s unique needs. We provide a wide range of services, including long-term care, private duty medical care, specialized care, and assistance for specific diseases, ensuring your loved ones receive the highest quality care in the comfort of their homes. Our dedicated team of caregivers, nurses, and therapists addresses physical, emotional, and social well-being, promoting independence, safety, and overall health. We support families through every stage of their health journey, providing peace of mind and enhancing quality of life.`,
      },
      {
        title: "Medical Staffing",
        description: `We efficiently fill short-term and long-term staffing gaps with qualified healthcare professionals. Our network covers last-minute shifts and seasonal support, ensuring smooth operations. We rigorously vet candidates for qualifications, experience, and compassion, guaranteeing a perfect fit for your team. Tailoring our solutions to meet the specific needs of each medical setting, we offer staffing for all specialties, including nurses and therapists. With Care Indeed, you can focus on exceptional patient care, trusting us to provide the right professionals to maintain high standards and operational excellence.`,
      },
    ],
  },
  "services-for-families": {
    header: "Services For Families",
    content: [
      {
        title: "Home Care",
        description: `Care Indeed’s Home Care services provide professionally trained caregivers offering around-the-clock care, hourly assistance, and expert medication management with flexible scheduling and comprehensive care plans.
        Our dedicated caregivers promote well-being, ensure safety, and provide companionship, allowing clients to age gracefully and comfortably at home. By fostering a supportive environment, Care Indeed helps clients stay engaged and active, reducing stress for families and providing peace of mind that their loved ones receive the highest quality of care, enhancing their overall quality of life.`,
      },
      {
        title: "One-on-One Hospital Sitter ",
        description: `Care Indeed’s one-on-one hospital sitters provide dedicated, around-the-clock support during hospital stays. Our sitters offer companionship, assistance, and continuous monitoring to promote healing, reduce infection risks, and prevent injuries. They assist with feeding, personal hygiene, medication schedules, and post-surgery precautions, ensuring patient comfort. While not interfering with medical staff duties, they run errands, maintain emergency contact information, and provide peace of mind. This support ensures better care during hospitalization and serves as a patient advocate throughout the medical stay.`,
      },
      {
        title: "Long-term Care",
        description: `Care Indeed’s Long-term Care services, including Personal Concierge and 72-hour Post-Discharge Care, help seniors maintain independence and enhance their quality of life at home. Our dedicated team manages every aspect of your loved one’s well-being with compassion and efficiency, providing consistent, reliable support tailored to individual needs. Our caregivers promote well-being, ensure safety, and provide companionship, reducing stress and anxiety. Families can rest assured knowing their loved ones receive the highest quality of care in a supportive and nurturing environment.`,
      },
      {
        title: "Private Duty Medical Care",
        description: `Care Indeed’s Private Duty Medical Care offers personalized, expert care through a dedicated team of skilled nurses, physical therapists, and occupational therapists. Our tailored care plans address each individual’s unique needs, promoting healing, recovery, and enhancing the overall quality of life. Families can trust that their loved ones receive comprehensive support for managing chronic conditions, recovering from injuries, and adapting to cognitive disabilities. Our services focus on reducing infection risk, preventing hospital readmission, and fostering independence, enabling clients to thrive in their home environments.`,
      },
      {
        title: "Specialized Care",
        description: `Care Indeed’s Specialized Care provides tailored, compassionate support to improve the quality of life for you or your loved one. Our dedicated caregivers and Certified Nurse Assistants (CNAs) offer seamless transitions from hospital to home, promoting safe recovery and reducing readmission risks. We deliver comprehensive assistance, including personal hygiene, mobility, and emotional well-being, allowing clients to regain independence at home. Our services also encompass compassionate hospice and palliative care, focusing on comfort and dignity. With Care Indeed’s Specialized Care, families can trust that their loved ones receive reliable, personalized care to thrive.`,
      },
      {
        title: "Disease Specialties",
        description: `Care Indeed provides tailored, compassionate care for individuals with chronic and progressive conditions such as Alzheimer’s, stroke, Parkinson's, and diabetes. Our expert caregivers manage daily activities, ensure proper nutrition and hygiene, and offer emotional support to enhance quality of life. Collaborating with healthcare professionals, we coordinate comprehensive care to help patients adhere to medical regimens, manage symptoms, and maintain independence. Our caregivers assist with daily tasks, facilitate exercise and therapy, and provide companionship, addressing all aspects of the patient’s well-being.`,
      },
    ],
  },
  "medical-staffing": {
    header: "Medical Staffing",
    image: {
      src: MedicalStaffingImage,
      alt: "Medical Staffing Image",
    },
    content: [
      {
        title: "Long-term Care",
        description: `Eliminate the challenges of staff shortages and unpredictable attendance with our comprehensive Long-Term Care Staffing Solutions. Ensure your facility operates seamlessly by outsourcing your recruitment and hiring to us, so you can focus on providing exceptional care to your patients or residents. We handle everything from screening and training to placement and even workers' compensation, ensuring all staff are our dedicated employees. Let us streamline your staffing needs, so you can maintain a consistent and reliable workforce.`,
      },
      {
        title: "Medical Settings",
        description: `Care Indeed provides expert staffing solutions for various medical settings, ensuring your facility is equipped with the right talent for exceptional patient care. We cater to long-term care facilities, hospitals, hospices, home health care, and urgent care clinics, addressing each environment’s unique needs with highly qualified healthcare professionals. Our rigorous screening process ensures you receive reliable, compassionate, and professional staff who seamlessly integrate into your team. With Care Indeed, your facility will run smoothly and efficiently with dedicated professionals committed to delivering exceptional care and support.`,
      },
      {
        title: "Extra Support to Offer Families",
        description: `Care Indeed's Supplemental Support Services transform the senior care landscape by meeting the evolving expectations of families and providing crucial support to your dedicated staff. We go beyond traditional staffing models with a comprehensive suite of services that empower residents to maintain independence and a sense of control through personalized concierge assistance. Our services reduce stress and workload for your staff with on-demand access to qualified concierge and healthcare professionals. We provide peace of mind to families by ensuring their loved ones receive exceptional care, fostering trust and stronger partnerships.`,
      },
      {
        title: "1:1 Hospital Sitter",
        description: `Care Indeed's compassionate hospital sitters provide constant monitoring to ease patient anxiety, improve safety, and support faster recovery in hospitals and other medical facilities. Our dedicated companions offer peace of mind when you can't be there 24/7. By partnering with Care Indeed, you show a commitment to resident well-being beyond hospitalization.
        Our Hospital Sitter program reduces anxiety, enhances recovery, and ensures clear communication for faster healing and smoother transitions home. Consistent support and proactive monitoring also help identify complications early, reducing the risk of readmission.`,
      },
    ],
  },
  "b2c-home-care": {
    header: "Home Care",
    image: {
      src: HomeCareImage,
      alt: "Home Care Image",
    },
    content: [
      {
        title: "Live-in and 24-hour Care",
        description: `Care Indeed’s live-in and 24-hour care services ensure comfort and dignity with discreet personal care, physical assistance, and household chores. Our caregivers help with bathing, oral hygiene, eating, dressing, toileting, transfers, ambulation, and maintaining a clean living environment.
        We provide transportation to appointments and activities, medication reminders, and manage daily errands, keeping you on track with your health regimen. Staying at home promotes well-being and peace of mind, and our caregivers are dedicated to meeting your needs, helping you age gracefully in your preferred environment. Families can trust that their loved ones receive the highest quality of care and support at home.`,
      },
      {
        title: "Hourly Care",
        description: `Care Indeed’s hourly home care services offer flexible scheduling to meet your needs, whether for 4 hours once a week or a 12-hour shift. We provide overnight care to ensure a good night’s sleep and offer safe, reliable transportation to help you or your loved one stay connected with friends, family, and the community. Our caregivers address a wide range of personal and lifestyle needs, including reading and writing assistance, ambulation and pet care, toileting, bathing, dressing, grooming, companionship, light housekeeping, meal preparation, and medication reminders. We also promote balanced dietary habits, mental stimulation, and conduct range-of-motion exercises to support overall well-being.`,
      },
      {
        title: "Medication Management",
        description: `Care Indeed’s Medication Management Program provides expert support from licensed nurses and pharmacists to ensure proper medication adherence. Our flexible, customizable program simplifies medication management, improves adherence, and enhances health outcomes. We handle medication delivery and refill management, offer medication education, review, administration, and monitoring services, and ensure safety through continuous monitoring for adverse drug reactions, all tailored to meet your unique needs.`,
      },
    ],
  },
  "b2c-one-on-one-hospital-sitter": {
    image: {
      src: OneOnOneHospitalSitterImage,
      alt: "One-on-One Hospital Sitter Image",
    },
    content: [
      {
        title: "One-on-One Hospital Sitter ",
        description: `Care Indeed’s one-on-one hospital sitters provide dedicated, around-the-clock support during hospital stays. Our sitters offer companionship, assistance, and continuous monitoring to promote healing, reduce infection risks, and prevent injuries.
        They assist with feeding, personal hygiene, medication schedules, and post-surgery precautions, ensuring patient comfort. While not interfering with medical staff duties, they run errands, maintain emergency contact information, and provide peace of mind. This support ensures better care during hospitalization and serves as a patient advocate throughout the medical stay.`,
      },
    ],
  },
  "b2c-long-term-care": {
    image: {
      src: LongTermCareImage,
      alt: "Long Term Care Image",
    },
    header: "Long-term Care",
    content: [
      {
        title: "Personal Concierge",
        description: `Care Indeed’s Personal Concierge service offers comprehensive support to alleviate stress and provide essential help for those needing care. Our concierges handle everything from organizing and grocery shopping to running errands, setting appointments, and providing companionship. This flexible and accessible service ensures every aspect of daily life is managed efficiently, helping families maintain balance and peace of mind while enjoying more quality time together.`,
      },
      {
        title: "72-Hour Post-Discharge",
        description: `Care Indeed’s 72-Hour Post-Discharge service ensures a safe, comfortable recovery for seniors transitioning home after a hospital stay. Our team of nurses and caregivers provides vital sign monitoring, medication reminders, meal preparation, light housekeeping, and transportation to follow-up appointments. This service helps seniors adhere to discharge instructions, manage medication schedules, and perform daily tasks. By offering reliable transportation, companionship, and emotional support, we reduce anxiety and promote a smooth recovery at home, providing peace of mind for families during this critical period.`,
      },
    ],
  },
  "b2c-private-duty-medical-care": {
    header: "Private Duty Medical Care",
    image: {
      src: PrivateDutyMedicalCareImage,
      alt: "Private Duty Medical Care Image",
    },
    content: [
      {
        title: "Skilled Nursing",
        description: `Our team of registered nurses (RNs) and licensed vocational nurses (LVNs) bring their expertise directly to your loved one. They'll work closely with you and your doctor to develop a personalized care plan that addresses your loved one's specific needs and recovery goals.
        We offer a comprehensive range of in-home skilled nursing services; including medication management, injections, and patient education.  We also specialize in post-surgery care, such as tracheostomy, nasogastric, and gastrostomy care. By choosing Care Indeed, families can trust that their loved ones receive expert clinical care that promotes healing, reduces infection risks, and enhances quality of life.`,
      },
      {
        title: "Physical Therapy",
        description: `Care Indeed’s Physical Therapy services provide essential support for individuals recovering from injuries, disabilities, or illness-related impairments. Our highly qualified therapists create personalized treatment plans to speed up recovery, reduce pain, and prevent long-term dependency on pain medications. Through hands-on care tailored to each client’s needs, we help regain mobility, improve strength, and enhance overall function. Each session starts with a thorough assessment to track progress and adjust treatment as needed. With consistent, professional care, our therapists work closely with other medical professionals to ensure top-quality therapy, enhancing recovery and improving quality of life.`,
      },
      {
        title: "Occupational Therapy",
        description: `Care Indeed’s Occupational Therapy services offer holistic support to help individuals recover from injuries or cognitive disabilities. Our therapists enhance quality of life by helping clients re-learn skills and incorporate new routines for improved physical, mental, and emotional health. We equip clients to maintain daily activities like meal preparation, using technology, managing finances, shopping, and driving. By assessing needs, observing challenges, and evaluating home environments, we ensure a safer living space and comprehensive care.`,
      },
    ],
  },
  "b2c-specialized-care": {
    header: "Specialized Care",
    image: {
      src: SpecializedCareImage,
      alt: "Specialized Care Image",
    },
    content: [
      {
        title: "Hospital to Home",
        description: `Care Indeed’s Hospital-to-Home Care, also known as Transitional Care, ensures a seamless transition from hospital to home, helping clients regain independence while ensuring safety. Our qualified caregivers and Certified Nurse Assistants (CNAs) provide personalized care to reduce hospital readmissions and promote quick recovery.
        Our comprehensive services include personal hygiene, incontinence care, ambulation assistance, companionship, meal preparation, shopping, light housekeeping, laundry, and pet care. We also focus on balanced diets, mental stimulation, social activities, transportation, and escort services for appointments and social events. With Care Indeed’s Hospital to Home Care, families can trust that their loved ones receive compassionate, comprehensive care for a safe and speedy recovery at home.`,
      },
      {
        title: "Hospice and Palliative Care",
        description: `Care Indeed offers professional, compassionate hospice and palliative care support, ensuring comfort, dignity, and empathy for terminally or chronically ill individuals. Our Certified Nurse Assistants (CNAs) provide 24/7 support in homes, rehabilitation centers, hospitals, and other settings.
        Hospice care focuses on end-of-life comfort and dignity, while palliative care improves the quality of life at any stage by addressing pain relief and stress reduction. With a commitment to comprehensive medical, emotional, and spiritual support, Care Indeed enhances the quality of life for patients and their families during this critical time.`,
      },
    ],
  },
  "b2c-disease-specialties": {
    header: "Disease Specialties",
    image: {
      src: DiseaseSpecialtiesImage,
      alt: "Dieasea Specialties Image",
    },
    content: [
      {
        title: "Alzheimer’s & Other Dementias",
        description: `Care Indeed’s caregivers manage essential tasks such as eating, bathing, dressing, grooming, sleeping, and toileting to ensure proper nutrition and hygiene for individuals with Alzheimer’s and other dementias.
        Our caregivers incorporate enjoyable activities into daily routines to provide consistency and familiarity, reducing agitation and improving mood. Additionally, they handle doctor’s appointments, communicate with healthcare professionals, and provide medication reminders, acting as advocates for your well-being.`,
      },
      {
        title: "Post Stroke",
        description: `Care Indeed provides specialized care for stroke survivors, offering essential support to help them adjust to life after a stroke. Our caregivers deliver physical, mental, and emotional assistance, focusing on daily activities such as personal care and hygiene. They encourage range-of-motion exercises and prescribed activities to help regain independence.
        Our caregivers manage doctor’s appointments, communicate with healthcare professionals, and provide medication reminders. Trained to recognize warning signs of another stroke, they act as vigilant advocates for your loved one’s health. With Care Indeed, families receive consistent support and companionship, reducing the challenges of caring for a stroke survivor and providing peace of mind.`,
      },
      {
        title: "Parkinson's Care",
        description: `Care Indeed provides specialized care for individuals with Parkinson's, supporting them and their families in coping with this progressive movement disorder. Our caregivers manage the physical, emotional, and mental challenges of Parkinson's, helping you or your loved one live well and thrive. They assist with diet, feeding techniques, elimination, and ambulation while offering support to combat depression and anxiety.
        Caregivers encourage active range-of-motion exercises and engage clients in enjoyable activities like classes and artwork, providing companionship to prevent isolation. Our caregivers ensure all aspects of care are addressed, offering the necessary support to live well with Parkinson's.`,
      },
      {
        title: "Diabetes",
        description: `Care Indeed provides comprehensive diabetes care for individuals with new diagnoses or those struggling with disease management. Our skilled nursing staff offers educational instruction, regular insulin checks, and proper observation to ensure symptom control and reduce the risk of serious complications. Our caregivers monitor blood sugar levels, plan meals, and provide dietary education to help clients reach their health goals.
        We promote active lifestyles and exercise to maintain blood sugar control and enhance well-being, while also addressing medication management, securing resources for supplies, and assessing changes in skin integrity and wound care. Additionally, we assist with regular health check-ups, immunizations, oral hygiene, and foot care, advocating on your or your loved one’s behalf.`,
      },
    ],
  },
  "b2b-long-term-care": {
    header: "Long-term Care",
    content: [
      {
        title: "Caregivers",
        description: `Ensure exceptional care and smooth operations in your facility with our dedicated caregivers in the San Francisco Bay Area. Our caregivers understand the importance of both a tender touch and efficiency. They are team players, adept at juggling the needs of multiple residents while supporting their co-workers. Our caregivers value their role in promoting quality of life for your residents and maintaining a seamless work environment. Whether you need immediate coverage for sick calls or are planning ahead for flu season, rely on us to fill your vacancies, allowing you to focus on other pressing matters.`,
      },
      {
        title: "Nurses",
        description: `Ensure seamless operations and exceptional patient care with our nursing services for per diem and long-term placements. Care Indeed quickly fills urgent shifts with pre-vetted LVNs and RNs, integrates reliable per diem nurses into your team, and secures long-term fits through rigorous vetting. Serving Bay Area senior communities, clinics, hospices, and hospitals, we reduce your administrative burden with dedicated staffing specialists and a user-friendly platform for posting positions, managing schedules, and accessing candidate information. Focus on patient care while we handle your staffing needs.`,
      },
      {
        title: "Medication Technicians",
        description: `Ensure the well-being of your residents with our Medication Technicians, vital for safety and health in senior care communities. Serving SNFs, CCRCs, ALFs, and Memory Care Units, our technicians administer medications accurately and on time. They review doctor’s orders, prepare and provide medications, monitor residents for side effects, maintain detailed records, and collaborate with healthcare professionals to ensure a coordinated care plan. Our Medication Technicians uphold the highest standards of care, creating a safe and healthy environment for all patients and residents.`,
      },
      {
        title: "Therapists",
        description: `Ensure consistent therapy and maximize recovery for your residents with Care Indeed’s reliable on-demand therapy staffing. Our physical therapists specialize in post-surgical rehabilitation, personalized exercise programs, and pain management, enhancing mobility and well-being. Our occupational therapists promote independence through improved daily living skills, cognitive rehabilitation, and adaptive equipment training, ensuring residents achieve optimal outcomes. Care Indeed is your trusted partner in ensuring your residents receive essential therapy without interruption.`,
      },
      {
        title: "Front Office Staff",
        description: `Ensure your clients’ first impression reflects your values of caring, professionalism, and friendliness with Care Indeed’s front office staffing solutions. Our pre-vetted receptionists greet clients warmly, manage calls, schedule appointments, and provide administrative support, embodying the professionalism and friendliness that sets the tone for your facility. Our highly qualified medical assistants seamlessly integrate into your team, taking vital signs, performing lab procedures, administering medications, maintaining patient records, and providing patient education, ensuring smooth operations and exceptional care.`,
      },
    ],
  },
  "b2b-medical-settings": {
    header: "Medical Settings",
    content: [
      {
        title: "Long-term Care Facilities",
        description: `Care Indeed ensures quality care for residents in long-term care facilities by bridging staffing gaps and maintaining continuity of care. Our experienced clinicians and support staff are dedicated to building relationships, enhancing residents' well-being, and maintaining a high quality of life. We create a familiar and supportive environment for your residents by providing a wide range of qualified healthcare professionals, including Registered Nurses (RNs), Licensed Vocational Nurses (LVNs), Certified Nurse Aides (CNAs), Physical Therapists (PTs), Occupational Therapists (OTs), Medication Technicians (MedTechs), Home Health Aides (HHAs), hospice professionals and front office staff. We also assist with placing other healthcare professionals based on your specific needs.`,
      },
      {
        title: "Hospital",
        description: `Care Indeed delivers the right talent to hospitals swiftly, ensuring exceptional care in a fast-paced environment. Our expert healthcare teams, including Registered Nurses (RNs), Licensed Vocational Nurses (LVNs), Certified Nurse Aides (CNAs), Physical Therapists (PTs), Occupational Therapists (OTs), Medication Technicians (MedTechs), Home Health Aides (HHAs), hospice professionals and front office staff, work tirelessly to address critical medical needs and ensure positive patient outcomes. We partner with a wide range of qualified healthcare professionals to meet your hospital’s unique needs, from essential medical care to specialized support.`,
      },
      {
        title: "Hospice Agencies",
        description: `Care Indeed provides compassionate and professional hospice caregivers who enhance the care environment for hospice patients and their families. Our CNAs and hospice caregivers offer 24/7 support, including holidays, to address both physical and emotional needs. Specializing in hospice care for terminally or chronically ill individuals, our caregivers focus on comfort, dignity, and empathy. We also provide skilled nurses specializing in hospice care and can place other healthcare professionals based on your facility's specific needs.`,
      },
      {
        title: "Home Health Agencies",
        description: `Care Indeed’s Medicare-certified home health care services provide skilled nursing, therapy, and personal care directly in the homes of individuals needing assistance. Our goal is to create a comforting and supportive environment for patients and their families, ensuring they receive the highest quality care at home. Our team includes home health aides, skilled nurses, and therapists who assist with daily living activities, deliver essential medical care, and offer physical and occupational therapy to help patients regain independence and improve their quality of life. With highly trained professionals, Care Indeed ensures exceptional home health care tailored to your unique needs.`,
      },
      {
        title: "Urgent Care Clinics",
        description: `Care Indeed provides urgent care clinics with adaptable staffing solutions to meet fluctuating patient volumes and diverse medical needs. Our flexible pool of qualified healthcare professionals is ready to address any situation, ensuring your clinic is equipped with the right talent at the right time. Our comprehensive staffing services enhance patient care and operational efficiency. With Care Indeed, your urgent care clinic is staffed with adaptable, qualified professionals dedicated to meeting your patients' diverse medical needs. You can confidently maintain high standards of care with Care Indeed.`,
      },
    ],
  },
  "b2b-extra-support-to-offer-families": {
    header: "Extra Support to Offer Families",
    image: {
      src: ExtraSupportForFamiliesImage,
      alt: "Extra Support For Families Image",
    },
    content: [
      {
        title: "72-Hour Post-Discharge",
        description: `Care Indeed’s 72-Hour Post Discharge Care provides essential one-on-one caregivers, or "Sitters," to monitor and address clients' needs during the critical first 72 hours after hospital discharge or a fall. This service helps prevent readmission and ensures immediate recovery, offering peace of mind to families.
        Our Sitters provide constant supervision and promptly address any issues to prevent complications. They can also help demonstrate the need for a higher level of care if necessary. Suggest our service to families, and we’ll handle the arrangements and billing directly, ensuring comprehensive support during this vulnerable period.`,
      },
      {
        title: "Personal Concierge",
        description: `Care Indeed’s Personal Concierge Service provides invaluable support for residents needing assistance with daily tasks while maintaining their independence. Our organized and compassionate concierges offer clerical help, companionship, and assistance with activities like attending events or sharing meals.
        Ideal for residents who need some help and enjoy social interaction, our concierges manage tasks with care, provide stimulating conversation, and build positive relationships to ensure well-being. Recommend our Personal Concierge Service to help residents stay engaged and happily independent, with all arrangements handled and billed directly by Care Indeed, ensuring peace of mind for families.`,
      },
      {
        title: "Medication Management",
        description: `Care Indeed’s Medication Management service offers comprehensive support to seniors needing help with their medications, ensuring safety and reducing family stress. Our nurses and geriatric care managers create personalized plans to address confusing schedules, missed doses, incorrect amounts, and potential side effects.
        We develop tailored medication management plans, ensure accurate administration, monitor for interactions, coordinate with doctors and pharmacies, and provide emotional support and education. This service empowers seniors to maintain control over their health care and gives families peace of mind.`,
      },
    ],
  },
  "b2b-1:1-hospital-sitter": {
    image: {
      src: OneOnOneHospitalSitterImage,
      alt: "One-on-One Hospital Sitter Image",
    },
    content: [
      {
        title: "One-on-One Hospital Sitter ",
        description: `Care Indeed's compassionate hospital sitters provide constant monitoring to ease patient anxiety, improve safety, and support faster recovery in hospitals and other medical facilities. Our dedicated companions offer peace of mind when you can't be there 24/7. By partnering with Care Indeed, you show a commitment to resident well-being beyond hospitalization.
        Our Hospital Sitter program reduces anxiety, enhances recovery, and ensures clear communication for faster healing and smoother transitions home. Consistent support and proactive monitoring also help identify complications early, reducing the risk of readmission.`,
      },
    ],
  },
} as const);

export type InquiryInfoState = keyof typeof inquiryInfoList;

export const CUSTOMER_STORIES_TESTIMONIALS = [
  {
    quote:
      "The whole company is really outstanding, they see to your needs if there’s a problem.",
    name: "Helen",
    role: "Care Recipient",
    rating: 5,
    videoURL: "https://cdn.careindeed.com/helen-testimonial.mp4",
    videoPreviewImage: HelenPreviewImage.src,
  },
  {
    quote:
      "The best thing about Care Indeed is that they really seem to care about the patients.",
    name: "Martin",
    role: "Family of a care recipient",
    rating: 5,
    videoURL: "https://cdn.careindeed.com/martin-testimonial.mp4",
    videoPreviewImage: MartinPreviewImage.src,
  },
  {
    quote: "The Care Indeed caregivers and I became like a close-knit family.",
    name: "Elise",
    role: "Family of a care recipient",
    rating: 5,
    videoURL: "https://cdn.careindeed.com/elise-testimonial.mp4",
    videoPreviewImage: ElisePreviewImage.src,
  },
];

export const TESTIMONIALS_FROM_PROFESSIONALS_TESTIMONIALS = [
  {
    quote: "I’ve gained a lot more experience and exposure at Care Indeed.",
    name: "Amanjit",
    role: "Care Indeed Nurse",
    rating: 5,
    videoURL: "https://cdn.careindeed.com/amanjit-testimonials.mp4",
    videoPreviewImage: AmanjitPreviewImage.src,
  },
  {
    quote: "Care Indeed pushed me further than I thought I would. ",
    name: "Kevin",
    role: "Care Indeed Caregiver",
    rating: 5,
    videoURL: "https://cdn.careindeed.com/kevin-testimonials.mp4",
    videoPreviewImage: KevinPreviewImage.src,
  },
];

export type Location = {
  logo: {
    src: string | StaticImport;
    alt: string;
  };
  name: string;
  address: {
    text: string;
    link: string;
  };
  phone: {
    text: string;
    link: string;
  };
};

export const OUR_LOCATIONS: Location[] = [
  {
    logo: {
      src: CampbellLogo,
      alt: "Campbell logo",
    },
    name: "Campbell",
    address: {
      text: "419 E Hamilton Ave, Campbell, CA 95008",
      link: "https://www.google.com/maps/place/419+E+Hamilton+Ave,+Campbell,+CA+95008,+USA/@37.2946012,-121.9448197,17z/data=!3m1!4b1!4m6!3m5!1s0x808e34d9fd6a6b05:0x26aba1fe239d3d0b!8m2!3d37.294597!4d-121.9422448!16s%2Fg%2F11bw40r1tw?entry=ttu&g_ep=EgoyMDI1MDExMC4wIKXMDSoASAFQAw%3D%3D",
    },
    phone: {
      text: "(650) 328-1001",
      link: "tel:6503281001",
    },
  },
  {
    logo: {
      src: MenloParkLogo,
      alt: "Menlo Park logo",
    },
    name: "Menlo Park",
    address: {
      text: "890 Santa Cruz Ave, Suite B Menlo Park, CA 94025",
      link: "https://www.google.com/maps/place/890+Santa+Cruz+Ave+%23+B,+Menlo+Park,+CA+94025,+USA/@37.450191,-122.1861599,17z/data=!3m1!4b1!4m6!3m5!1s0x808fa4ba9f0f4539:0xbd4a9db46c640635!8m2!3d37.450191!4d-122.1861599!16s%2Fg%2F11mhjxkd2z?entry=ttu&g_ep=EgoyMDI0MTIwMy4wIKXMDSoASAFQAw%3D%3D",
    },
    phone: {
      text: "(650) 328-1001",
      link: "tel:6503281001",
    },
  },
  {
    logo: {
      src: SanMateoLogo,
      alt: "San Mateo logo",
    },
    name: "San Mateo",
    address: {
      text: "102 S El Camino Real, San Mateo, CA 94401",
      link: "https://www.google.com/maps/place/102+S+El+Camino+Real,+San+Mateo,+CA+94401,+USA/@37.5640658,-122.3274478,17z/data=!3m1!4b1!4m6!3m5!1s0x808f9e71789ee527:0xce9100a0f9b044a0!8m2!3d37.5640658!4d-122.3274478!16s%2Fg%2F11c26l4jrw?entry=ttu",
    },
    phone: {
      text: "(650) 328-1001",
      link: "tel:6503281001",
    },
  },
  {
    logo: {
      src: SanJoseLogo,
      alt: "San Jose logo",
    },
    name: "San Jose",
    address: {
      text: "358 S Redwood Ave, San Jose, CA 95128",
      link: "https://www.google.com/maps/place/358+S+Redwood+Ave,+San+Jose,+CA+95128,+USA/data=!4m2!3m1!1s0x808fcb201cb6e84d:0xf93fa8e9475dbc86?sa=X&ved=2ahUKEwizu56tnI2EAxXTcWwGHdThCHwQ8gF6BAgREAA",
    },
    phone: {
      text: "(650) 328-1001",
      link: "tel:6503281001",
    },
  },
];

export type AboutUsService = {
  image: {
    src: string | StaticImageData;
    alt: string;
  };
  title: string;
  description: string;
  link: {
    href: string;
    text: string;
  };
};

export const SERVICES_ABOUT_US: AboutUsService[] = [
  {
    image: {
      src: ServicesForFamiliesHeaderImage,
      alt: "Services for Families Image",
    },
    title: "Services for Families",
    description:
      "We give families peace of mind through personalized care plans, allowing them to focus on creating cherished memories while we support them through every stage of their health journey.",
    link: {
      href: "/families",
      text: "View Services for Families",
    },
  },
  {
    image: {
      src: MedicalStaffingHeaderImage,
      alt: "Medical Staffing Image",
    },
    title: "Facilities",
    description:
      "We help ensure seamless operations by efficiently filling short-term and long-term gaps with qualified professionals, providing reliable support and maintaining high-quality care.",
    link: {
      href: "/staffing/medical-staffing",
      text: "View Staffing for Facilities",
    },
  },
];

/**
  image: { src: string; alt: string };
  title?: string;
  description?: string;
  className?: string;
  button: {
    children: string;
    href: string;
  };
 */
export const LOCATIONS_SERVICES_DATA: LocationsServiceType[] = [
  {
    serviceType: "Families",
    locationsServiceItems: [
      {
        title: "Home Care",
        description:
          "Our Home Care services include professionally trained and state-registered caregivers offering around-the-clock care, hourly assistance, and expert medication management to support clients throughout their health journey.",
        image: {
          src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2Fed3ed849c9664723886a8b176991ff2e",
          alt: "Home Care Service",
        },
        button: {
          children: "Learn More",
          href: "/home-care",
        },
      },
      {
        title: "1:1 Hospital Sitter",
        description:
          "Our sitters offer companionship, assistance, and continuous monitoring to promote healing, reduce infection risks, and prevent injuries or falls.",
        image: {
          src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2Fb58feaf824d84d1980d94b1b358d00e0",
          alt: "1:1 Hospital Sitter Service",
        },
        button: {
          children: "Learn More",
          href: "/families/sitter",
        },
      },
      {
        title: "Long-term Care",
        description:
          "Care Indeed Long-term Care helps seniors maintain independence and enhance their quality of life in the comfort of their own homes.",
        image: {
          src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2Fb066b27158894fa98faf154b7c8fb335",
          alt: "Long-term Care Service",
        },
        button: {
          children: "Learn More",
          href: "/long-term-care",
        },
      },
      {
        title: "Private Duty Medical Care",
        description:
          "Private Duty Medical Care is provided by our dedicated team of skilled nurses, physical therapists, and occupational therapists who work closely with clients and their healthcare teams to create tailored care plans that address each individual's unique needs.",
        image: {
          src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F7589692c228e4fddb0b5b372bdabb98b",
          alt: "Private Duty Medical Care Service",
        },
        button: {
          children: "Learn More",
          href: "/private-duty-nurse",
        },
      },
      {
        title: "Specialized Care",
        description:
          "Our tailored, one-on-one care focuses on improving quality of life, ensuring you or your loved one receives compassionate and professional assistance.",
        image: {
          src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F94a69722c37540a188c1b731f9520828",
          alt: "Specialized Care Service",
        },
        button: {
          children: "Learn More",
          href: "/families/special-care",
        },
      },
      {
        title: "Disease Specialties",
        description: `Our expert caregivers enhance quality of life by managing daily activities, ensuring proper nutrition and hygiene, and offering emotional support. Our caregivers collaborate with healthcare professionals to coordinate comprehensive care, helping patients adhere to medical regimens, manage symptoms, and maintain independence.`,
        image: {
          src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F82de4ec9263a42ad8489ce90b8a97d2d",
          alt: "Disease Specialties Service",
        },
        button: {
          children: "Learn More",
          href: "/families/disease-specialties",
        },
      },
    ],
  },
  {
    serviceType: "Facilities",
    locationsServiceItems: [
      {
        title: "Long-term Care",
        description: `Our services include caregivers, nurses, medication technicians, therapists, and front office staff, with staffing solutions such as on-demand staffing for immediate needs, supplemental staffing to bridge gaps, and direct hire placements for long-term team members.`,
        image: {
          src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F7dd4038f7dc84403878779eb565e1e20",
          alt: "Long-term Care Staffing",
        },
        button: {
          children: "Learn More",
          href: "/staffing/long-term-care",
        },
      },
      {
        title: "Medical Settings",
        description:
          "Care Indeed provides expert staffing solutions tailored to various medical settings, ensuring your facility is equipped with the right talent for exceptional patient care.",
        image: {
          src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F03b14845bd714019bf2e8fa8483b98ab",
          alt: "Medical Settings Staffing",
        },
        button: {
          children: "Learn More",
          href: "/staffing/medical-settings",
        },
      },
      {
        title: "Extra Support to Offer Families",
        description: `Care Indeed's Supplemental Support Services transform the senior care landscape by meeting the evolving expectations of families and providing crucial support to your dedicated staff.`,
        image: {
          src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2Fdc706c0082c948069457ea4d97696165",
          alt: "Extra Support to Offer Families",
        },
        button: {
          children: "Learn More",
          href: "/staffing/family-support",
        },
      },
      {
        title: "1:1 Hospital Sitter",
        description: `Our caregivers deliver 1:1 hospital sitting services in Campbell, offering constant support and care for patients during their hospital stays, ensuring safety and comfort.`,
        image: {
          src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F539cd98628dd4c65beab899e3a2083b7",
          alt: "1:1 Hospital Sitter",
        },
        button: {
          children: "Learn More",
          href: "/staffing/hospital-sitter",
        },
      },
    ],
  },
];
